import { Alert } from '@artprov/design-system'
import { useEffect, useMemo, useState } from 'react'
import { AlertContext } from './use-alert.hook'

/** @typedef {import('./alert').AlertOptions} AlertOptions */

const DEFAULT_OPTIONS = {
  duration: 5000,
  autoDismiss: true,
  variant: 'warning',
}

/**
 * @param {{children: import('react').ReactNode}} children
 */
export function AlertProvider({ children }) {
  //NOSONAR:S6774
  const [open, setOpen] = useState(false)
  /** @type {ReturnType<typeof useState<AlertOptions>>} */
  const [options, setOptions] = useState(DEFAULT_OPTIONS)

  useEffect(() => {
    if (!open) setOptions(DEFAULT_OPTIONS)
  }, [open])

  const obj = useMemo(
    () => ({
      /** @param {AlertOptions} options */
      show: (options) => {
        setOpen(true)
        setOptions((old) => ({ ...old, ...options }))
      },
      hide: () => {
        setOpen(false)
        // setOptions((old) => ({ ...old, ...options }))
      },
    }),
    []
  )

  const iconStyles = {
    error: 'text-error-10',
    success: 'text-success-10',
    warning: 'text-warning-10',
    info: 'text-info-10',
  }
  return (
    <AlertContext.Provider value={obj}>
      {children}
      {open && (
        <span className="absolute top-24 right-5 ">
          <Alert
            duration={options.duration}
            onClose={() => setOpen(false)}
            autoDismiss={options.autoDismiss}
            variant={options.variant}
            title={options?.title || ''}
            descriptionStyle={'break-words'}
            description={options.description}
            icon={options?.icon || 'error'}
            iconStyle={iconStyles[options?.variant] || iconStyles.error}
            containerStyle="w-[336px]"
          />
        </span>
      )}
    </AlertContext.Provider>
  )
}
